//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

export const PRODUCT_DETAILS_SAVED_TOAST = {
  title: 'Product Details Saved',
  message: 'Your product details were saved to this campaign request.',
};

export const VARIANT_DETAILS_SAVED_TOAST = {
  title: 'Variant Details Saved',
  message: 'Your variant details were saved to this campaign request.',
};
